import React, { Children, useState } from "react";

import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";

// import JS files
import { useUserData } from "../../context/UserDataContext";
import MuiTheme from "./MuiTheme";

// import Others files

const Input = styled("input")({
  display: "none",
});
const UploadButton = styled(Button)({
  color: "#FA8443",
  border: "2px solid #FA8443",
  "&:hover": {
    backgroundColor: "transparent",
    color: "#FA8443",
  },
  "&:active": {},
  "&:focus": {},
});

const MuiUpload = ({ setImageFile , accept,disabled  , id="id"}) => {
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (
      (file.type.includes("image/") && file.size <= 1000000) ||
      (file.type.includes("video/") && file.size <= 5000000)
    ) {
      setImageFile(file);
    } else if (file.size <= 5000000) {
      setImageFile(file);
    } else {
      toast.error("حجم فایل انتخابی شما بیشتر از مقدار مجاز است، در صورت بارگذاری تصویر، حجم تصویر باید کم تر از یک مگ باشد.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    e.target.value = null;
  };

  return (
    <>
      <MuiTheme>
        <label htmlFor={id}>
          <Input
            accept={accept}
            id={id}
            type="file"
            onChange={(e) => handleFile(e)}
            disabled={disabled}
          />
          <UploadButton
            variant="text"
            component="span"
            style={{ display: "flex" }}
          >
            <span>آپلود فایل</span>
          </UploadButton>
        </label>
      </MuiTheme>
    </>
  );
};

export default MuiUpload;
